import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Button } from 'antd';
import Content from '@/Layouts/containers/Content';
import Header from '@/Components/Header';
import Icon from '@ant-design/icons';
import { ReactComponent as Back } from '@skytvnz/sky-app-style/lib/assets/svg/icons/icon_back.svg';
import useMedia from '@/Hooks/useMedia';
import { PageViewedAnalyticsProps } from '@/Analytics/Page';
import Background, { BackgroundType } from '@/Layouts/containers/Background';
import useMyHubMenu from '@/Hooks/useMyHubMenu';
import classNames from 'classnames';
import { getNonDesktopBrowser } from '@/Utils/Browser';
import useOrientation from '@/Hooks/useOrientation';
import MyhubMenu from './Menu/MyhubMenu';

import styles from './styles.module.scss';
import NotFound from '../NotFound';
import { Menu } from './Constants';

const MyHub: React.FC = () => {
  const { sectionId = '' } = useParams<any>();
  const { menuList } = useMyHubMenu();
  const { isPortrait } = useOrientation();
  const { isMediaXs, isMediaS, isMediaM } = useMedia();
  const history = useHistory();
  const [segmentPayload] = useState<PageViewedAnalyticsProps>();

  const onBackButtonClick = () => {
    history.goBack();
  };
  const BackButton: React.FC = () => {
    return (
      <Button className={styles.backButton} onClick={onBackButtonClick} type="link">
        <Icon className={styles.closeIcon} component={Back as React.FC} />
        Back to Sky Go
      </Button>
    );
  };

  const MenuItem = menuList.find(item => item.link.includes(sectionId));
  let backgroundType = BackgroundType.Default;
  if (MenuItem?.value === Menu.ManageDevices && isMediaXs && !isMediaS) {
    backgroundType = BackgroundType.OmitXs;
  }

  return (
    <Background
      type={backgroundType}
      className={classNames(
        styles.myHubWrapper,
        getNonDesktopBrowser(),
        isPortrait && 'portrait-mode',
      )}
    >
      <Background className={styles.headerContainer} type={BackgroundType.Default}>
        <Header disableMenuItems />
        {!isMediaM && <MyhubMenu selectedSection={sectionId} menuList={menuList} />}
      </Background>

      <Content className={styles.myHubContainer}>
        {isMediaM && (
          <div className={styles.sidePanal}>
            <BackButton />
            <MyhubMenu selectedSection={sectionId} menuList={menuList} />
          </div>
        )}
        <div className={styles.menuItemContainer}>
          <h1>My Hub</h1>
          {MenuItem && MenuItem.value !== Menu.ManageDevices && <MenuItem.component />}
          {MenuItem && MenuItem.value === Menu.ManageDevices && (
            <MenuItem.component segmentPayload={segmentPayload} />
          )}
          {!MenuItem && <NotFound className={styles.myHubNotFound} />}
        </div>
      </Content>
    </Background>
  );
};

export default MyHub;
